// NK — versteckt durchgestrichene 0,00€-Preise, die Shopify fälschlich rendert,
// wenn compare_at_price = 0 auf einer Variante gesetzt ist.
// Kann entfernt werden, sobald die Produktdaten im Admin Bulk-Fix bereinigt sind.
(function () {
  var ZERO_RE = /(^|\s)(0[.,]00\s*(€|EUR)?|€\s*0[.,]00|EUR\s*0[.,]00)\s*$/;

  function fix(root) {
    var nodes = (root || document).querySelectorAll(
      's.price-item--regular, .price__sale .price-item--regular'
    );
    for (var i = 0; i < nodes.length; i++) {
      var txt = (nodes[i].textContent || '').trim();
      if (ZERO_RE.test(txt)) {
        nodes[i].classList.add('nk-is-zero');
        nodes[i].style.display = 'none';
      }
    }
  }

  document.documentElement.classList.add('js-nk-hide-zero-compare');
  if (document.readyState !== 'loading') fix();
  else document.addEventListener('DOMContentLoaded', fix);

  // Für AJAX-Reloads (Filter, Variant-Change)
  var obs = new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      if (muts[i].addedNodes && muts[i].addedNodes.length) {
        fix();
        break;
      }
    }
  });
  obs.observe(document.body || document.documentElement, {
    childList: true,
    subtree: true,
  });
})();
